"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconArrowLeft', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M18.99875,9.00025 L3.41275,9.00025 L7.70575,4.70725 C8.09675,4.31625 8.09675,3.68425 7.70575,3.29325 C7.31475,2.90225 6.68275,2.90225 6.29175,3.29325 L0.29275,9.29225 C0.19975,9.38425 0.12675,9.49525 0.07575,9.61825 C-0.02525,9.86225 -0.02525,10.13825 0.07575,10.38225 C0.12675,10.50525 0.19975,10.61625 0.29275,10.70825 L6.29175,16.70725 C6.48675,16.90225 6.74275,17.00025 6.99875,17.00025 C7.25475,17.00025 7.51075,16.90225 7.70575,16.70725 C8.09675,16.31625 8.09675,15.68425 7.70575,15.29325 L3.41275,11.00025 L18.99875,11.00025 C19.55175,11.00025 19.99875,10.55325 19.99875,10.00025 C19.99875,9.44725 19.55175,9.00025 18.99875,9.00025'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;